module.exports = __webpack_public_path__ + "img/6.9c9ff31c.png";